/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import deleteBtsHistoryActions, {
    deleteBtsHistoryTypes,
} from '../../../redux/collectData/deleteBtsHistory'
import getBtsHistoryActions from '../../../redux/collectData/getBtsHistory'
import { Delete } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* deleteBtsHistorySagas({ response }) {
    try {
        const responseDelete = yield Delete(`csv/bts_data/${response.id}`)
        if (responseDelete.status === 200 || responseDelete.status === 201) {
            yield all([
                yield put(getBtsHistoryActions.getBtsHistoryRequest()),
                yield put(
                    deleteBtsHistoryActions.deleteBtsHistorySuccess(
                        responseDelete.data
                    )
                ),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
            ])
        } else {
            yield put(
                deleteBtsHistoryActions.deleteBtsHistoryFailure(
                    responseDelete.data
                )
            )
        }
    } catch (error) {
        yield put(deleteBtsHistoryActions.deleteBtsHistoryFailure(error))
    }
}

export function* deleteBtsHistorySaga() {
    yield takeLatest(
        deleteBtsHistoryTypes.DELETE_BTS_HISTORY_REQUEST,
        deleteBtsHistorySagas
    )
}
